export const WINDOW_PADDING = 30; // footer height 29px
